import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
import OpendoorTestimonials from "../components/marketing/OpendoorTestimonials";

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <OpendoorTestimonials />,
    document.getElementById("opendoor__testimonials")
  );
});
